/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    fill: #eee;
  }
  .none {
    fill: none;
  }
`

export default function FriendsInvitationIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" css={Color}>
      <g id="friend" transform="translate(-1226 -291)">
        <rect id="사각형_6317" data-name="사각형 6317" width="22" height="22" transform="translate(1226 291)" opacity="0"/>
        <path id="합치기_238" data-name="합치기 238" d="M7.5,16.32H0V12.669A6.646,6.646,0,0,1,10.4,7.182a6.647,6.647,0,0,1,10.4,5.487v3.65Zm1.3-3.65v2.35H19.5v-2.35a5.35,5.35,0,0,0-10.7,0Zm-7.5,0v2.35H7.5v-2.35A6.627,6.627,0,0,1,9.365,8.06,5.286,5.286,0,0,0,6.65,7.319,5.357,5.357,0,0,0,1.3,12.669ZM11.515,2.8a2.8,2.8,0,1,1,2.8,2.8A2.8,2.8,0,0,1,11.515,2.8Zm1.3,0a1.5,1.5,0,1,0,1.5-1.5A1.5,1.5,0,0,0,12.815,2.8Zm-9.06,0a2.8,2.8,0,1,1,2.8,2.8A2.8,2.8,0,0,1,3.755,2.8Zm1.3,0a1.5,1.5,0,1,0,1.5-1.5A1.5,1.5,0,0,0,5.054,2.8Z" transform="translate(1226.6 294.33)"/>
      </g>
    </svg>
  )
}
